import { useContext } from 'react';
import { UsersContext } from '../../contexts/user.context';

export const useLoginData = () => {
  const { user } = useContext(UsersContext) ?? {};

  return {
    user,
  };
};
